import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "transactions__list"
}
const _hoisted_2 = { class: "transaction__date" }
const _hoisted_3 = { class: "transactions__info" }
const _hoisted_4 = { class: "transactions__name" }
const _hoisted_5 = {
  key: 1,
  class: "transactions__list"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "transactions__item" }, "Отсутствуют операции", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tab = _resolveComponent("tab")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    title: "История транзакций",
    subtitle: "",
    class: "trans-modal"
  }, {
    body: _withCtx(() => [
      _createVNode(_component_tabs, { onTabChanged: _ctx.changeTab }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (i, idx) => {
            return (_openBlock(), _createBlock(_component_tab, {
              key: idx,
              title: i.title
            }, {
              default: _withCtx(() => [
                (_ctx.trans.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trans, (item, ind) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "transactions__item",
                          key: ind
                        }, [
                          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dateFilter(item.created_at)), 1),
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(item.sum > 0 ? "Пополнение баланса" : item.provider), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["transactions__value", { 'transactions__value--positive': item.sum > 0 }])
                            }, _toDisplayString(item.sum) + " ₸ ", 3)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              ]),
              _: 2
            }, 1032, ["title"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onTabChanged"])
    ]),
    _: 1
  }))
}